export default __webpack_public_path__ + "static/media/groupimg.b7cdb2f0.svg";